export enum ACTIONS_TYPES  {
    ADD_CAMERA_ITEM = 'ADD_CAMERA_ITEM',
    REMOVE_CAMERA_ITEM = 'REMOVE_CAMERA_ITEM',
    RESET_CAMERAS_ITEMS = 'RESET_CAMERAS_ITEMS',
    INCREMENT_CAMERA_COUNT = 'INCREMENT_CAMERA_COUNT',
    DECREMENT_CAMERA_COUNT = 'DECREMENT_CAMERA_COUNT',
    SET_LOCATION_INSTALL = 'SET_LOCATION_INSTALL',
    SET_PLAN = 'SET_PLAN',
    SET_OPTION = 'SET_OPTION',
    INCREMENT_CAMERA_PRICE_WITH_COUNT = 'INCREMENT_CAMERA_PRICE_WITH_COUNT',
    DECREMENT_CAMERA_PRICE_WITH_COUNT = 'DECREMENT_CAMERA_PRICE_WITH_COUNT',
    SET_RESET_ALL = 'SET_RESET_ALL',
    INCREMENT_TOTAL_COUNT_CAMERAS = 'INCREMENT_TOTAL_COUNT_CAMERAS',
    DECREMENT_TOTAL_COUNT_CAMERAS = 'DECREMENT_TOTAL_COUNT_CAMERAS',
    RESET_TOTAL_COUNT_CAMERAS = 'RESET_TOTAL_COUNT_CAMERAS',
    INCREMENT_INJECTOR = 'INCREMENT_INJECTOR',
    DECREMENT_INJECTOR = 'DECREMENT_INJECTOR',
    RESET_INJECTOR = 'RESET_INJECTOR',
    INIT_INJECTOR = 'INIT_INJECTOR',
}
